import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Header from "./Home/Nav3";
import Footer from "./Home/Footer1";
import ScrollReveal from "./Home/ScrollReveal";
import Home from "./Home";
import BlogIndex from "./blog/BlogIndex";
import BlogPost from "./blog/BlogPost";
import BdfPage from "./products/BdfPage";
import { I18nProvider } from "./i18n";
import "./site.css";

const App = () => {
  return (
    <I18nProvider>
      <Router>
        <div className="nfw-site">
          <ScrollReveal />
          <Header />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/products/bdf" component={BdfPage} />
            <Route exact path="/products/cwp">
              <Redirect to={{ pathname: "/", hash: "cwp" }} />
            </Route>
            <Route exact path="/blog" component={BlogIndex} />
            <Route exact path="/blog/:slug" component={BlogPost} />
            <Route exact path="/about-us">
              <Redirect to={{ pathname: "/", hash: "about" }} />
            </Route>
            <Redirect to="/" />
          </Switch>
          <Footer />
        </div>
      </Router>
    </I18nProvider>
  );
};

export default App;
